module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAABCBAMAAADAnRmrAAAAD1BMVEX///////////////////+Rd1MVAAAABHRSTlMAEJ/PUreMHgAAAHFJREFUOMvt0MENgCAQRNGRCog2oMYGSKhApv+aFGRhl5t35rT5eacF6ohxs8wyy7+yelOWAzGYsiVcyauyxBuOQZWNOwRRCASxEUFsRBA7qYidVERFPkRFPkRNCqImBdGQjGhIRrTkRbyHF7qRAKccDxXzH53mhWbIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// /opt/buildhome/repo/src/assets/images/arrows/cursor-down-light-2x.png
// module id = ../../../../../src/assets/images/arrows/cursor-down-light-2x.png
// module chunks = styles